import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { LogoIcon } from "@tamagui/logo";
import { Play } from "@tamagui/lucide-icons";
import { Button, Square, useControllableState, useEvent } from "tamagui";
function AnimationsDemo(props) {
  const [positionI, setPositionI] = useControllableState({
    strategy: "most-recent-wins",
    prop: props.position,
    defaultProp: 0
  });
  const position = positions[positionI];
  const onPress = useEvent(() => {
    setPositionI((x) => {
      return (x + 1) % positions.length;
    });
  });
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Square,
      {
        animation: props.animation || "bouncy",
        onPress,
        size: 104,
        borderColor: "$borderColor",
        borderWidth: 1,
        borderRadius: "$9",
        backgroundColor: "$color9",
        hoverStyle: {
          scale: 1.1
        },
        pressStyle: {
          scale: 0.9
        },
        ...position,
        children: props.children || /* @__PURE__ */ jsx(LogoIcon, { downscale: 0.75 })
      }
    ),
    /* @__PURE__ */ jsx(
      Button,
      {
        position: "absolute",
        bottom: 20,
        left: 20,
        icon: Play,
        theme: props.tint,
        size: "$5",
        circular: true,
        onPress
      }
    )
  ] });
}
const positions = [
  {
    x: 0,
    y: 0,
    scale: 1,
    rotate: "0deg"
  },
  {
    x: -50,
    y: -50,
    scale: 0.5,
    rotate: "-45deg",
    hoverStyle: {
      scale: 0.6
    },
    pressStyle: {
      scale: 0.4
    }
  },
  {
    x: 50,
    y: 50,
    scale: 1,
    rotate: "180deg",
    hoverStyle: {
      scale: 1.1
    },
    pressStyle: {
      scale: 0.9
    }
  }
];
export {
  AnimationsDemo,
  positions
};
//# sourceMappingURL=AnimationsDemo.js.map
